import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Row as VDSRow, Col as VDSCol } from '@vds/grids';
import ChatAndC2C from './ChatAndC2C/redesign';
import VideoChat from './VideoChat/redesign';

export const FWARow = styled(VDSRow)`
  ${({ colGutter, children }) =>
    colGutter &&
    children &&
    `
    margin-left : -${colGutter};
    margin-right : -${colGutter};
    & > div:not(&) {
      padding-left: ${colGutter};
      padding-right: ${colGutter};
    }
`}
`;

const QuickLinks = ({ enableLiveSupport, renderQuickLinks, title }) => {
  const chatArea = document.getElementById('c2c_wrapper_desktop');
  const chatLink = document.getElementById('LPMcontainer-1676894258022-7');
  const callLink = document.querySelector('[aria-label="click-to-call"]');
  const videoCallLink = document.querySelector('[aria-label="Video Call"]');
  const videocallArea = document.getElementById('videoChatCol');
  const messageIcon = document.getElementById('inqC2CImgContainer_Fixed1');
  const dom2 = document.querySelector('[aria-label="Message Us"]');

  useEffect(() => {
    // focus for video icon

    const dom = document.getElementById('c2c-container-5g-desktop');
    if (videoCallLink && videocallArea) {
      videocallArea.setAttribute('tabindex', '0');
      if (dom && dom?.children?.length > 0) {
        dom.setAttribute('tabindex', '0');
        dom.children[0].setAttribute('tabindex', '-1');
      }
    }

    // focus for chat icon
    else if (chatLink) {
      chatLink.setAttribute('tabindex', '0');
      if (dom && dom?.children?.length > 0) {
        dom.setAttribute('tabindex', '0');
      }
    }

    // focus for messageicon
    else if (messageIcon && dom2) {
      if (dom && dom?.children?.length > 0) {
        dom.setAttribute('tabindex', '0');
      }
    }

    // focus for call icon
    else if (callLink && chatArea) {
      if (dom && dom?.children?.length > 0) {
        dom.setAttribute('tabindex', '0');
      }
    }
    if (callLink) {
      callLink.setAttribute('tabindex', '-1');
    }
  }, [videoCallLink, chatLink, callLink, chatArea, dom2, messageIcon]);

  return (
    <FWARow end="xs" colGutter="15px">
      <VDSCol key="quickLinks">{renderQuickLinks && typeof renderQuickLinks === 'function' && renderQuickLinks()}</VDSCol>
      {enableLiveSupport && (
        <React.Fragment key="liveSupportFragment">
          <VDSCol key="videoChatCol">
            <VideoChat title={title} />
          </VDSCol>
          <VDSCol key="chatCol">
            <ChatAndC2C />
          </VDSCol>
        </React.Fragment>
      )}
    </FWARow>
  );
};
QuickLinks.propTypes = {
  enableLiveSupport: PropTypes.bool,
  renderQuickLinks: PropTypes.oneOf([PropTypes.node, PropTypes.arrayOf(PropTypes.node)]),
  title: PropTypes.string,
};

export default QuickLinks;
